import { createTheme } from "@mui/material";


export const SDETheme = createTheme ({
  palette: {
    primary: {
      main: "#b0b0b0",
    },
    secondary: {
      main: "#f7941d",
    },
    sdeBrown: {
      main: "#c49c80",
      light: "#fff6f0",
    },
    sdePurple: {
      main: "#c187e8",
    },
    sdeBlue: {
      main: "#87b1e8",
      light: "#bfd5f3",
    },
    sdeGreen: {
      main: "#92e887"
    },
    grey: {
      main: '#b0b0b0',
      medium: "#cccccc",
      light: '#efefef',
      dark: '#787878',
    }
  },
  typography: {
    fontFamily: 'Source Sans Pro',
    useNextVariants: true,
    suppressDeprecationWarnings: true,
    h1: {
      fontFamily: 'Merriweather',
      fontWeight: 900,
      fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
      lineHeight: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
      letterSpacing: "-.05rem"
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: "2rem"
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: "1.75rem"
    },
    h3: {
      fontWeight: 700,
      fontSize: "2.5rem",
    },
    h5: {
      fontWeight: 900,
      fontSize: "1.5rem"
    },
    h6: {
      fontWeight: 900
    },
    body1: {
      fontWeight: 600
    },
    body2: {
      fontWeight: 400
    },
    button: {
      textTransform: 'none'
    }
  },
  overrides: {
    MuiButton: {
      margin: 0,
    },
  },
});